// extracted by mini-css-extract-plugin
export default {"tableButton-container":"Button2_tableButton-container__+vxEF","image":"Button2_image__cpVu6"};